const data = [
  {
    title: "Scroll Progress Bar",
    shortDescription:
      "A colored line at the top of the screen that grows as you scroll down. Just like the 'reading time' bar on Medium or news sites.",
    description:
      "This project is a math problem disguised as a UI component. To build it, we need to calculate a percentage: *'How much of the page have I covered?'* We use the formula: `(How far you've scrolled / Total height of page) * 100`. If the result is 50%, we simply set the CSS `width` of a `<div>` to `50%`. It updates in real-time to tell the user exactly how much content is left to read.",
  },
];

export default data;